import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import AdminDashboard from "./pages/AdminDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import MentorDashboard from "./pages/MentorDashboard";
import StudentAuth from "./pages/StudentAuth";
import MentorAuth from "./pages/MentorAuth";
import NotFound from "./pages/NotFound";
import MentorApplication from "./pages/MentorApplication";
import AllMentors from "./pages/AllMentors";
import Auth from "./pages/Auth";
import MentorProfile from "./pages/MentorProfile";
import MentorSlugProfile from "./pages/MentorSlugProfile";
import SearchResults from "./pages/SearchResults";
import { AuthGuard } from "./components/AuthGuard";
import { ScrollToTop } from "./components/ScrollToTop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Support from "./pages/Support";
import SupportTickets from "./pages/SupportTickets";
import SessionRoom from "./pages/SessionRoom";
import CookiePolicy from "./pages/CookiePolicy";
import TestEmailSend from "./pages/TestEmailSend";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/mentors" element={<AllMentors />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/dashboard/admin" element={
            <AuthGuard requiredRole="admin">
              <AdminDashboard />
            </AuthGuard>
          } />
          <Route path="/dashboard/student" element={
            <AuthGuard requiredRole="student">
              <StudentDashboard />
            </AuthGuard>
          } />
          <Route path="/dashboard/mentor" element={
            <AuthGuard requiredRole="mentor">
              <MentorDashboard />
            </AuthGuard>
          } />
          <Route path="/auth/student" element={<StudentAuth />} />
          <Route path="/auth/mentor" element={<MentorAuth />} />
          <Route path="/mentor/apply" element={<MentorApplication />} />
          <Route path="/mentor/:mentorId" element={<MentorProfile />} />
          <Route path="/auth/login" element={<Auth />} />
          <Route path="/auth/register" element={<Auth />} />
          
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support/tickets" element={<AuthGuard><SupportTickets /></AuthGuard>} />
          <Route path="/test-email-send" element={<AuthGuard requiredRole="admin"><TestEmailSend /></AuthGuard>} />
          <Route path="/session/:sessionId" element={<AuthGuard><SessionRoom /></AuthGuard>} />

          {/* Custom mentor slug routes - must be before catch-all */}
          <Route path="/:slug" element={<MentorSlugProfile />} />

          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;